import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { months } from 'src/constants';
import { getDataFormat } from 'src/helpers';

import s from './style.module.scss';

const BlackAndWhite = ({ setOnRendered }) => {
  const { currentResume } = useSelector((state) => state.templatesReducer);

  const { image } = currentResume;

  useEffect(() => {
    const img = document.getElementById('avatar');
    if (img) {
      const imgAvatar = document.getElementById('avatar');
      imgAvatar.onload = () => {
        setOnRendered(true);
      };
    } else {
      setOnRendered(true);
    }
  }, []);

  return (
    <>
      {currentResume && (
        <div className={s.cari}>
          <div className={s.cari__left}>
            <div className="section-col">
              <div className="section">
                {image && (
                  <div className={s.avatar__wrap}>
                    <div className={s.avatar}>
                      <img width={166} src={image} alt="avatar" id="avatar" />
                    </div>
                  </div>
                )}
              </div>
              <div className="section">
                <div className={s.about}>
                  <div className={s.name}>Contacts</div>

                  <div className={s.about__block}>
                    <div className={s.title__left}>Phone</div>
                    <div className={s.text}>{currentResume.phone}</div>
                  </div>

                  <div className={s.about__block}>
                    <div className={s.title__left}>Email</div>
                    <div className={s.text}>{currentResume.email}</div>
                  </div>

                  <div className={s.about__block}>
                    <div className={s.title__left}>Adress</div>
                    <div className={s.text}>
                      {currentResume.country.name}, {currentResume.city.name}
                    </div>
                    <div className={s.text}>
                      {currentResume.state} {currentResume.zip}
                    </div>
                  </div>
                </div>
              </div>

              {currentResume.languages.length > 0 && (
                <div className="section">
                  <div className={s.about}>
                    <div className={s.name}>Languagess</div>
                    {currentResume.languages.map((item) => (
                      <div className={s.skill} key={item.id}>
                        {item.language} - {item.proficiency}
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {currentResume.hardSkills.length > 0 && (
                <div className="section">
                  <div className={s.about}>
                    <div className={s.name}>Hard skills</div>
                    {currentResume.hardSkills.map((item) => (
                      <div className={s.skill} key={item.id}>
                        {item.skill}
                      </div>
                    ))}
                  </div>
                </div>
              )}
              {currentResume.softSkills.length > 0 && (
                <div className="section">
                  <div className={s.about}>
                    <div className={s.name}>Soft skills</div>
                    {currentResume.softSkills.map((item) => (
                      <div className={s.skill} key={item.id}>
                        {item.skill}
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className={s.cari__right}>
            <div className="section-col">
              <div className="section section-first-page">
                <div className={s.title__wrap}>
                  <div className={s.title}>
                    <b>{currentResume.firstName}</b> {currentResume.lastName}
                  </div>
                  <div className={s.title2}>{currentResume.jobTitle}</div>
                </div>
              </div>
              {currentResume.experiences.length > 0 && (
                <div className="section">
                  {currentResume.experiences.map((item) => (
                    <div className={`sub-section ${s.work__sub__section}`} key={item.id}>
                      <div className={s.work}>
                        <div className={s.work__title}>Experiences</div>

                        <div className={s.work__wrap}>
                          <div className={s.work__data}>
                            {getDataFormat(item.startDate)} -{' '}
                            {item.isPresent ? 'Present' : getDataFormat(item.endDate)}
                          </div>
                          <div className={s.work__name}>{item.companyName}</div>
                          <div className={s.work__job}>{item.jobTitle}</div>
                          <div className={s.text}>{item.responsibilities}</div>
                          <div className={s.text}>{item.achievements}</div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}

              {currentResume.educations.length > 0 && (
                <div className="section">
                  {currentResume.educations.map((item) => (
                    <div className={`sub-section ${s.work__sub__section}`} key={item.id}>
                      <div className={s.work}>
                        <div className={s.work__title}>Education</div>

                        <div className={s.work__wrap}>
                          <div className={s.work__data}>
                            {months[item.graduationMonth].name} {item.graduationYear}
                          </div>
                          <div className={s.work__job}>{item.universityName}</div>
                          <div className={s.work__name}>
                            {item.country.name}, {item.city.name}
                          </div>

                          <div className={s.text}>{item.achievements}</div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}

              {currentResume.hobbies.length > 0 && (
                <div className="section">
                  {currentResume.hobbies.map((item) => (
                    <div className={`sub-section ${s.work__sub__section}`} key={item.id}>
                      <div className={s.work}>
                        <div className={s.work__title}>Hobbies</div>

                        <div className={s.work__wrap}>
                          <div className={s.work__job}>{item.name}</div>

                          <div className={s.text}>{item.description}</div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}

              {currentResume.certificates.length > 0 && (
                <div className="section">
                  {currentResume.certificates.map((item) => (
                    <div className={`sub-section ${s.work__sub__section}`} key={item.id}>
                      <div className={s.work}>
                        <div className={s.work__title}>Certifications</div>

                        <div className={s.work__wrap}>
                          <div className={s.work__job}>{item.name}</div>

                          <div className={s.text}>{item.skills}</div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

BlackAndWhite.propTypes = {
  setOnRendered: PropTypes.func.isRequired,
};
export default BlackAndWhite;
